import { Stack, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { TrendingDown, TrendingUp } from "@mui/icons-material";

export const GrowthIndicator = ({ value }: { value: number | null }) => {
  if (value === null || value === 0) {
    return (
      <Stack direction="row" spacing={0.4} alignItems="center" color="#94a3b8">
        <RemoveIcon sx={{ fontSize: 14 }} />
      </Stack>
    );
  }

  if (value > 0) {
    return (
      <Stack direction="row" spacing={0.4} alignItems="center" color="#22c55e">
        <TrendingUp sx={{ fontSize: 14 }} />
        <Typography fontSize={12} fontWeight={600}>
          {value}%
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={0.4} alignItems="center" color="#ef4444">
      <TrendingDown sx={{ fontSize: 14 }} />
      <Typography fontSize={12} fontWeight={600}>
        {Math.abs(value)}%
      </Typography>
    </Stack>
  );
};
